// extracted by mini-css-extract-plugin
export default {"event-container":"Event_event-container__IVAe8"};